export namespace NewRelicActionTypes {
  export const InitNewRelic = '[NewRelic] Init';
  export const SetAttributes = '[NewRelic] SetAttributes';
}
